import React from 'react';
import styled from 'styled-components';
import { Colors } from '../../../colors/Colors';
import phone from '../../../images/newProductPage/phone/phone_mockup.png';

const Wrapper = styled.section`
  background-color: ${Colors.gray};
  padding: 60px 0 60px 0;
  display: flex;
  flex-direction: column;
  align-items: center;

  @media (max-width: 600px) {
    margin-top: -100px;
  }
`;

const Title = styled.h1`
  color: var(--secondary-color);
  font-size: 40px;
  margin-bottom: 20px;
  font-weight: 900 !important;

  @media (max-width: 600px) {
    font-size: 36px;
    text-align: center;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  padding: 0px;
  width: 120px;
  border-radius: 30px !important;
  transform: translateZ(0);
  overflow: hidden;
`;

const SecondSectionTitle = styled.div`
  display: flex;
  justify-content: center;
  padding: 0px 30px;
  margin-top: 40px;
  max-width: 1200px;

  @media (max-width: 1200px) {
    margin-top: 0px;
  }

  @media (max-width: 600px) {
    width: 100%;
    text-align: center;
    margin-top: 80px;
    flex-direction: column;
  }
`;

const ImageWrapperCase = styled.div`
  position: absolute;
  width: 120px;
`;

const Category = styled.h1`
  display: flex;
  align-items: center;
  justify-content: left;
  gap: 10px;
  color: var(--secondary-color);
  text-align: left;
  font-size: 24px;
  font-weight: 800 !important;

  img:first-of-type {
    display: none;
  }

  img:last-of-type {
    display: flex;
  }
`;

const ItemsWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: ${(props) =>
    props.position % 2 === 0 ? 'row' : 'row-reverse'};

  @media (max-width: 600px) {
    flex-direction: column;
  }
`;

const DescriptionWrapper = styled.p`
  display: flex;
  gap: 8px;
  margin-top: 2px;
  list-style-type: circle;

  color: var(--secondary-color);
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

const Point = styled.div`
  margin-top: 8px;
  min-height: 7px;
  max-height: 7px;
  min-width: 7px;
  max-width: 7px;
  background-color: var(--secondary-color);
  border-radius: 50%;
  margin-left: 10px;
`;

const ItemWrapper = styled.div`
  width: 500px;

  @media (max-width: 1000px) {
    width: 400px;
  }

  @media (max-width: 800px) {
    width: 300px;
  }

  @media (max-width: 600px) {
    width: 90%;
    margin-top: 40px;
  }
`;

const ItemWrapperImage = styled(ItemWrapper)`
  display: flex;
  justify-content: center;
`;

const Learning = ({ data }) => {
  return (
    <Wrapper>
      <SecondSectionTitle>
        <Title>{data.title}</Title>
      </SecondSectionTitle>
      {data.config.map((c, i) => (
        <ItemsWrapper position={i}>
          <ItemWrapper>
            <Category>{c.category}</Category>
            <div style={{ marginTop: '12px' }}>
              <DescriptionWrapper>{c.description}</DescriptionWrapper>
              <ul>
                {c.descriptions?.map((d) => (
                  <DescriptionWrapper>
                    <Point />
                    <div>
                      <b>{d.bold}</b> {d.rest}
                    </div>
                  </DescriptionWrapper>
                ))}
              </ul>
            </div>
          </ItemWrapper>
          <ItemWrapperImage>
            <ImageWrapper>
              <ImageWrapperCase>
                <img
                  src={phone}
                  alt='phone'
                  style={{ width: '100%', height: '242px' }}
                />
              </ImageWrapperCase>
              <div
                style={{
                  marginLeft: '8px',
                  width: '105px',
                  height: '242px',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <img
                  src={c.image}
                  alt='Mobile Razgoto'
                  style={{ width: '100%', height: 'auto' }}
                />
              </div>
            </ImageWrapper>
          </ItemWrapperImage>
        </ItemsWrapper>
      ))}
    </Wrapper>
  );
};

export default Learning;
